import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {CallbackComponent} from "./callback.component";
import {CbNaverComponent} from "./cb-naver/cb-naver.component";
import {CbNaverIosComponent} from "./cb-naver-ios/cb-naver-ios.component";
import {CbNaverAndroidComponent} from "./cb-naver-android/cb-naver-android.component";


const childRoutes: Routes = [
  {
    path: '',
    redirectTo: 'naver',
    pathMatch: 'full',
  },
  {
    path: 'naver',
    component: CbNaverComponent,
  },
  {
    path: 'naver-ios',
    component: CbNaverIosComponent,
  },
  {
    path: 'naver-android',
    component: CbNaverAndroidComponent,
  },
];


const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent,
    children: childRoutes,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class CallbackRoutingModule {
}
